<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="mode === 'create'">{{"DEVICE_MODE_CREATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'update'">{{"DEVICE_MODE_UPDATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'read'">{{"DEVICE_MODE_READ" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>

    <mat-horizontal-stepper [linear]="true" #stepper *ngIf="!readOnly">
      <mat-step [completed]="firstStepCheckIfCompleted()">
        <ng-template matStepLabel>{{'INFORMATION'|translate}}</ng-template>

        <form [formGroup]="deviceForm" *ngIf="deviceForm">

          <div *ngIf="mode ==='create'" class="deviceTypeFilter" style="padding: 0px" placement="top"
               [ngbTooltip]="'DEVICE_TYPE_CHIPS' | translate">
            <mat-error *ngIf="device_type.invalid">{{getErrorMessageDeviceType()}}</mat-error>
            <app-device-type-selector [deviceTypeSelected]="deviceTypeSelected"
                                      (deviceTypeChanged)="filterListByDeviceType($event)"></app-device-type-selector>
          </div>

          <div *ngIf="mode ==='update'" class="deviceTypeFilter" style="padding: 0px">
            <mat-chip-list>
              <mat-chip class="selected">
                {{getDeviceTypeSelected()}}
              </mat-chip>
            </mat-chip-list>
          </div>
          <br clear="both"/>

          <mat-form-field>
            <input matInput [placeholder]="'UID' | translate" formControlName="uid" required>
            <mat-error *ngIf="uid.invalid">{{getErrorMessageUid()}}</mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.PtV5">
            <input matInput [placeholder]="'UID_ERP' | translate" formControlName="uid_erp" >
            <mat-error *ngIf="uid_erp.invalid">{{getErrorMessageUidErp()}}</mat-error>
          </mat-form-field>


          <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.LirisV2 || deviceTypeSelected === DeviceTypes.LirisV3">
            <mat-select formControlName="length" [placeholder]="'LENGTH' | translate">
              <mat-option *ngFor="let length of lengthForLiris" [value]="length.value">{{length.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.OpticV5">
            <mat-select formControlName="length" [placeholder]="'LENGTH' | translate">
              <mat-option *ngFor="let length of lengthForOptV5" [value]="length.value">{{length.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.VSensor || deviceTypeSelected === DeviceTypes.GSensor">
            <mat-select formControlName="unit" [placeholder]="'UNIT' | translate">
              <mat-option *ngFor="let unit of unitList" [value]="unit.id">{{unit.value | translate}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-slide-toggle formControlName="active">{{deviceForm.value.active ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
          </mat-slide-toggle>

          <div>
            <button class="btn btn-info" mat-button
                    matStepperNext
                    (click)="errorMessageIfInvalidForm(deviceForm.get('uid'))"
                    [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>

      </mat-step>

      <!--LIRIS V2-->
      <mat-step [stepControl]="paramFormLirisV2" *ngIf="deviceTypeSelected === DeviceTypes.LirisV2">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Liris V2</ng-template>
        <app-liris-v2 [paramFormLirisV2]="paramFormLirisV2" [readOnly]="false"></app-liris-v2>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>


      <!--INCLINO V2-->
      <mat-step [stepControl]="paramFormInclinoV2" *ngIf="deviceTypeSelected === DeviceTypes.InclinoV2 || deviceTypeSelected === DeviceTypes.InclinobiaxisV2">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Inclino V2</ng-template>
        <app-inclino-v2 [paramFormInclinoV2]="paramFormInclinoV2" [readOnly]="false"></app-inclino-v2>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--OPT V5-->
      <mat-step [stepControl]="paramFormOptV5" *ngIf="deviceTypeSelected === DeviceTypes.OpticV5">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Optical V5</ng-template>
        <app-opt-v5 [paramFormOptV5]="paramFormOptV5" [readOnly]="false" [typesOptV5]="typesOptV5"></app-opt-v5>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--EXT V5-->
      <mat-step [stepControl]="paramFormExtV5" *ngIf="deviceTypeSelected === DeviceTypes.ExtV5">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} External V5</ng-template>
        <app-ext-v5 [paramFormExtV5]="paramFormExtV5" [readOnly]="false"></app-ext-v5>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--liris_v3-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.LirisV3">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}}Liris V3</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--liris_v3_420-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.Liris420V3" [stepControl]="paramFormLiris420">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}}Liris V3_420</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>


      <!--exteg-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.Exteg">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}}EXTEG</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>


      <!--inclino v3-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.InclinoV3">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Inclino V3</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--expe-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.Expe">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Expe</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--extenso v3-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.ExtV3">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Extenso V3</ng-template>
        <app-liris-v3 [deviceParamLirisV3]="device.params"
                      [sensorType]="deviceTypeSelected"></app-liris-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--gateway v3-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.GatewayV3">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Gateway V3</ng-template>
        <app-gateway-v3 [deviceParamGatewayV3]="device.params"></app-gateway-v3>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--dau v5-->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.DauV5">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} DAU v5</ng-template>
        <app-dau-v5 [paramFormDauV5]="paramFormDauV5" [mode]="mode"
                    [deviceUid]="deviceForm.controls.uid.value"></app-dau-v5>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!--v_sensor -->
      <mat-step *ngIf="deviceTypeSelected === DeviceTypes.VSensor"
                [stepControl]="deviceForm.get('params')">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} Virtual sensor</ng-template>
        <app-v-sensor [deviceParams]="deviceForm.get('params')"
                      [readOnly]="false"
                      [deviceUid]="deviceForm.controls.uid.value"
                      [associatedLocationId]="project_device_location?.id"
                      [associatedProjectId]="project_device_location?.project?.id">
        </app-v-sensor>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button
                  matStepperNext
                  (click)="errorMessageIfInvalidForm(deviceForm.get('params'))"
                  [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <!-- DeviceParamWavesoft -->
      <mat-step *ngIf="deviceTypeSelected >= 1000">
        <ng-template matStepLabel>{{'PARAMETERS_FOR' | translate}} {{getDeviceTypeSelected()}}</ng-template>
        <app-wavesoft-device [paramFormWavesoftDevice]="paramFormWaveSoftDevices"
                             [readOnly]="false"></app-wavesoft-device>
        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
            Next
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>
        <div><b [innerHtml]="'INFORMATION'|translate">Type an UID</b></div>

        <div class="deviceTypeFilter" style="padding: 0px">
          <mat-chip-list>
            <mat-chip class="selected">
              {{getDeviceTypeSelected()}}
            </mat-chip>
          </mat-chip-list>
        </div>
        <br clear="both"/>

        <mat-form-field class="readonly">
          <input matInput [placeholder]="'UID' | translate" [value]="deviceForm.value.uid" [readonly]="true">
        </mat-form-field>

        <mat-form-field class="readonly" *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.PtV5">
          <input matInput [placeholder]="'UID_ERP' | translate" [value]="deviceForm.value.uid_erp" [readonly]="true">
        </mat-form-field>

        <mat-form-field *ngIf="deviceTypeSelected === 1 || deviceTypeSelected === 6" class="readonly">
          <mat-select [value]="deviceForm.value.length" [placeholder]="'LENGTH' | translate"
                      [disabled]="true">
            <mat-option *ngFor="let length of lengthForLiris" [value]="length.value">{{length.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="deviceTypeSelected === 2" class="readonly">
          <mat-select [value]="deviceForm.value.length" [placeholder]="'LENGTH' | translate"
                      [disabled]="true">
            <mat-option *ngFor="let length of lengthForOptV5" [value]="length.value">{{length.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.VSensor" class="readonly">
          <mat-select [value]="deviceForm.value.unit" [placeholder]="'UNIT' | translate" [disabled]="true">
            <mat-option *ngFor="let unit of unitList" [value]="unit.id">{{unit.value | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-slide-toggle [(ngModel)]="deviceForm.value.active" [disabled]="true"> {{deviceForm.value.active ?
          ('ACTIVE' | translate) : ('INACTIVE' | translate)}}
        </mat-slide-toggle>

        <span *ngIf="deviceTypeSelected === DeviceTypes.LirisV2">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Liris V2</b></div>
                     <app-liris-v2 [paramFormLirisV2]="paramFormLirisV2" [readOnly]="true"></app-liris-v2>
                </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.InclinoV2 || deviceTypeSelected === DeviceTypes.InclinobiaxisV2">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Inclino V2</b></div>
                         <app-inclino-v2 [paramFormInclinoV2]="paramFormInclinoV2" [readOnly]="true"></app-inclino-v2>
                </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.OpticV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Optical V5</b></div>
               <app-opt-v5 [paramFormOptV5]="paramFormOptV5" [readOnly]="true" [typesOptV5]="typesOptV5"></app-opt-v5>
                </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.ExtV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  External V5</b></div>
                <app-ext-v5 [paramFormExtV5]="paramFormExtV5" [readOnly]="true"></app-ext-v5>
                </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.LirisV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}} Liris V3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.Liris420V3">
                     <div><b>{{'PARAMETERS_FOR' | translate}} Liris V3_420</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.Exteg">
                     <div><b>{{'PARAMETERS_FOR' | translate}} EXTEG</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.InclinoV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Inclino V3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.Expe">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Expe</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.ExtV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Extenso v3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.GatewayV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Gateway v3</b></div>
            <app-gateway-v3 [editable]="false"
                            [deviceParamGatewayV3]="device.params"></app-gateway-v3>
            </span>

        <span *ngIf="deviceTypeSelected === DeviceTypes.DauV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  DAU v5</b></div>
                <app-dau-v5 [readOnly]="true" [mode]="mode" [paramFormDauV5]="paramFormDauV5"
                            [deviceUid]="deviceForm.controls.uid.value"></app-dau-v5>
            </span>

        <!--v_sensor -->
        <span *ngIf="deviceTypeSelected === DeviceTypes.VSensor">
                     <div><b>{{('PARAMETERS_FOR' | translate) + ' ' + ('VIRTUAL_SENSOR' | translate)}}</b></div>
                    <app-v-sensor [deviceParams]="deviceForm.get('params')"
                                  [readOnly]="true"
                                  [deviceUid]="deviceForm.controls.uid.value"
                                  [associatedLocationId]="project_device_location?.id"
                                  [associatedProjectId]="project_device_location?.project?.id">
                    </app-v-sensor>
                </span>

        <span *ngIf="deviceTypeSelected >= 1000">
                     <div><b>{{'PARAMETERS_FOR' | translate}} {{getDeviceTypeSelected()}}</b></div>
                <app-wavesoft-device [readOnly]="true"
                                     [paramFormWavesoftDevice]="paramFormWaveSoftDevices"></app-wavesoft-device>
            </span>


        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button type="button" class="btn btn-warning" (click)="persistDevice()">
            <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
            {{'SAVE'|translate}}
          </button>
          <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate"
                  *ngIf="needChildOrParent()">
            Next
          </button>
        </div>
      </mat-step>


      <mat-step *ngIf="needChildOrParent()">
        <ng-template matStepLabel>{{'DEVICE_ADD_CHILD'|translate}}</ng-template>
        <div *ngIf="deviceTypeSelected === DeviceTypes.DauV5">
          <app-device-children [device]="device" [type]="2" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
          <app-device-children [device]="device" [type]="3" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
          <app-device-children [device]="device" [type]="4" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
        </div>
        <div *ngIf="deviceTypeSelected === DeviceTypes.SpcuV5">
          <app-device-children [device]="device" [type]="12" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
        </div>

        <div *ngIf="deviceTypeSelected === DeviceTypes.Liris420V3">
          <app-device-children [device]="device" [type]="3" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
          <app-device-children [device]="device" [type]="16" [typeList]="deviceTypes"
                               [deviceId]="deviceId"></app-device-children>
        </div>


        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>

        </div>
      </mat-step>


    </mat-horizontal-stepper>


    <div *ngIf="readOnly" style="margin:0px 20px">
      <div><b [innerHtml]="'INFORMATION'|translate">Type an UID</b></div>

      <div class="deviceTypeFilter" style="padding: 0px">
        <mat-chip-list>
          <mat-chip class="selected">
            {{getDeviceTypeSelected()}}
          </mat-chip>
        </mat-chip-list>
      </div>
      <br clear="both"/>

      <mat-form-field class="readonly">
        <input matInput [placeholder]="'UID' | translate" [value]="deviceForm.value.uid" [readonly]="true">

      </mat-form-field>
      <mat-form-field class="readonly" *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.PtV5">

        <input matInput [placeholder]="'UID_ERP' | translate" [value]="deviceForm.value.uid_erp" [readonly]="true">

      </mat-form-field>

      <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.LirisV2 || deviceTypeSelected === DeviceTypes.LirisV3" class="readonly">
        <mat-select [value]="deviceForm.value.length" [placeholder]="'LENGTH' | translate"
                    [disabled]="true">
          <mat-option *ngFor="let length of lengthForLiris" [value]="length.value">{{length.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>



      <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.OpticV5" class="readonly">
        <mat-select [value]="deviceForm.value.length" [placeholder]="'LENGTH' | translate"
                    [disabled]="true">
          <mat-option *ngFor="let length of lengthForOptV5" [value]="length.value">{{length.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="deviceTypeSelected === DeviceTypes.ExtV5 || deviceTypeSelected === DeviceTypes.VSensor || deviceTypeSelected === DeviceTypes.GSensor"
                      class="readonly">
        <mat-select [value]="deviceForm.value.unit" [placeholder]="'UNIT' | translate" [disabled]="true">
          <mat-option *ngFor="let unit of unitList" [value]="unit.id">{{unit.value | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-slide-toggle [(ngModel)]="deviceForm.value.active" [disabled]="true"> {{deviceForm.value.active ?
        ('ACTIVE' | translate) : ('INACTIVE' | translate)}}
      </mat-slide-toggle>

      <span *ngIf="deviceTypeSelected === DeviceTypes.LirisV2">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Liris V2</b></div>
                     <app-liris-v2 [paramFormLirisV2]="paramFormLirisV2" [readOnly]="true"></app-liris-v2>
                </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.InclinoV2 || deviceTypeSelected === DeviceTypes.InclinobiaxisV2">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Inclino V2</b></div>
                         <app-inclino-v2 [paramFormInclinoV2]="paramFormInclinoV2" [readOnly]="true"></app-inclino-v2>
                </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.OpticV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Optical V5</b></div>
               <app-opt-v5 [paramFormOptV5]="paramFormOptV5" [readOnly]="true" [typesOptV5]="typesOptV5"></app-opt-v5>
                </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.ExtV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  External V5</b></div>
                <app-ext-v5 [paramFormExtV5]="paramFormExtV5" [readOnly]="true"></app-ext-v5>
                </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.LirisV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}} Liris V3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.Liris420V3">
                     <div><b>{{'PARAMETERS_FOR' | translate}} Liris V3_420</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.Exteg">
                     <div><b>{{'PARAMETERS_FOR' | translate}} EXTEG</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>
      <span *ngIf="deviceTypeSelected === DeviceTypes.InclinoV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Inclino V3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>
      <span *ngIf="deviceTypeSelected === DeviceTypes.Expe">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Expe</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>
      <span *ngIf="deviceTypeSelected === DeviceTypes.ExtV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Extenso v3</b></div>
            <app-liris-v3 [editable]="false"
                          [deviceParamLirisV3]="device.params" [sensorType]="deviceTypeSelected"></app-liris-v3>
            </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.GatewayV3">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  Gateway v3</b></div>
            <app-gateway-v3 [editable]="false"
                            [deviceParamGatewayV3]="device.params"></app-gateway-v3>
            </span>

      <span *ngIf="deviceTypeSelected === DeviceTypes.DauV5">
                     <div><b>{{'PARAMETERS_FOR' | translate}}  DAU v5</b></div>
                <app-dau-v5 [readOnly]="true" [mode]="mode" [paramFormDauV5]="paramFormDauV5"
                            [deviceUid]="deviceForm.controls.uid.value"></app-dau-v5>
            </span>

      <!--v_sensor -->
      <span *ngIf="deviceTypeSelected === DeviceTypes.VSensor">
                     <div><b>{{'PARAMETERS_FOR' | translate}} Virtual sensor</b></div>
                    <app-v-sensor [deviceParams]="deviceForm.get('params')"
                                  [readOnly]="true"
                                  [deviceUid]="deviceForm.controls.uid.value"
                                  [associatedLocationId]="project_device_location?.id"
                                  [associatedProjectId]="project_device_location?.project?.id">
                    </app-v-sensor>
                </span>
      <span *ngIf="deviceTypeSelected >= 1000">
                     <div><b>{{'PARAMETERS_FOR' | translate}} {{getDeviceTypeSelected()}}</b></div>
                <app-wavesoft-device [readOnly]="true"
                                     [paramFormWavesoftDevice]="paramFormWaveSoftDevices"></app-wavesoft-device>
            </span>
    </div>


  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="closeModal()" [innerHTML]="'CLOSE' | translate">Close
    </button>
  </div>
</ng-template>


<button *ngIf="mode ==='read'  && !displayLink && !childrenDeviceHasDeviceType()" type="button" class="btn list-tools"
        (click)="openModal(content)"
        placement="left"
        [ngbTooltip]="'READ_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEye"></fa-icon>
</button>

<button *ngIf="mode ==='create' && authenticationService.userIsLevelZero()" type="button" class="btn top-list-tools"
        (click)="openModal(content)" placement="left"
        [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faPlus"></fa-icon>
  {{'ADD_DEVICE'|translate}}
</button>


<button *ngIf="mode ==='update' && !displayLink" type="button" class="btn list-tools" (click)="openModal(content)"
        placement="top"
        [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEdit"></fa-icon>
</button>


<a *ngIf="mode ==='read' && displayLink" class="linkInList" (click)="openModal(content)" placement="right"
   [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" [innerHtml]="displayLink"></a>

<a *ngIf="mode ==='update' && displayLink" class="linkInList" (click)="openModal(content)" placement="right"
   [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" [innerHtml]="displayLink"></a>


<mat-chip class="list-chip" *ngIf="mode ==='read' && childrenDeviceHasDeviceType() && !displayLink" placement="right"
          [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" matBadgePosition="below after"
          [matBadgeColor]="getBadegColor(children_device.device_type.id)" [matBadge]="children_device.channel"
          (click)="openModal(content)"
          matTooltipPosition="left"
          [matTooltip]=" (children_device.device_type.type|translate) + ' ' + children_device.channel + ' | ' + children_device.uid">
  {{mouseover === true ? (children_device.device_type.type|translate) : ('SHORT_' +
children_device.device_type.type|translate) }}
</mat-chip>


<!--<button *ngIf="mode ==='delete'" type="button" class="btn list-tools" style="background: red" (click)="deleteDevice(content)"-->
<!--placement="left"-->
<!--ngbTooltip="Click to delete this item"><app-progressbar *ngIf="showSpinnerDelete===true"></app-progressbar>-->
<!--<fa-icon [pulse]="showSpinnerDelete" [icon]="faTrashAlt"></fa-icon>-->
<!--</button>-->
